import React, { useMemo, useState } from "react";

const ProductCard = ({
  productId,
  image,
  name,
  price,
  promo_price,
  promo_active,
  colors = [],
}) => {
  const [selectedColorIndex, setSelectedColorIndex] = useState(0);

  const hasColors = Array.isArray(colors) && colors.length > 0;
  const selectedColor = hasColors ? colors[selectedColorIndex] : null;

  const displayImage = useMemo(() => {
    if (selectedColor?.image_url) {
      if (selectedColor.image_url.startsWith("http")) return selectedColor.image_url;
      if (selectedColor.image_url.startsWith("/")) return selectedColor.image_url;
      return `/${selectedColor.image_url}`;
    }
    return image;
  }, [selectedColor, image]);

  const isPromo = Boolean(promo_active && promo_price);
  const finalPrice = isPromo ? Number(promo_price) : Number(price);

  return (
    <a href={`/product/${productId}`} className="product-card">
      <div className="product-card-media">
        <img
          src={displayImage}
          alt={name}
          className="product-card-image"
          loading="lazy"
        />

        {isPromo && <span className="product-badge">Offre</span>}
      </div>

      <div className="product-card-body">
        <div className="product-card-top">
          <h3 className="product-card-title">{name}</h3>

          <div className="product-price-block">
            {isPromo ? (
              <>
                <span className="product-old-price">{Number(price).toFixed(2)}€</span>
                <span className="product-price">{finalPrice.toFixed(2)}€</span>
              </>
            ) : (
              <span className="product-price">{finalPrice.toFixed(2)}€</span>
            )}
          </div>
        </div>

        <p className="product-card-text">
          {hasColors
            ? `${colors.length} coloris disponible${colors.length > 1 ? "s" : ""}.`
            : "Pièce artisanale aux finitions soignées."}
        </p>

        {hasColors && (
          <div className="product-colors" onClick={(e) => e.preventDefault()}>
            {colors.slice(0, 5).map((color, index) => (
              <button
                key={`${color.color_name}-${index}`}
                type="button"
                className={`color-dot ${selectedColorIndex === index ? "is-active" : ""}`}
                style={{ backgroundColor: color.color_code || "#d8d0c9" }}
                onClick={() => setSelectedColorIndex(index)}
                aria-label={color.color_name || `Couleur ${index + 1}`}
                title={color.color_name || `Couleur ${index + 1}`}
              />
            ))}
          </div>
        )}

        <div className="product-card-footer">
          <span className="text-link">Voir le produit</span>
        </div>
      </div>
    </a>
  );
};

export default ProductCard;